import { ComponentPadder } from '../generic/Layouts'
import Layout from './Layout'

export {
    ComponentPadder
};

export default Layout
